import React, { useState } from 'react';
import { ReservationForm } from '@types';

const ReservationSection: React.FC = () => {
  const [formData, setFormData] = useState<ReservationForm>({
    name: '',
    phone: '',
    person: '1-person',
    date: '',
    time: '08:00am',
    message: '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      // TODO: Call API endpoint
      console.log('Reservation data:', formData);
      alert('Reservation submitted successfully!');
    } catch (error) {
      console.error('Error submitting reservation:', error);
      alert('Failed to submit reservation. Please try again.');
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section className="reservation">
      <div className="container">
        <div className="form reservation-form bg-black-10">
          <form onSubmit={handleSubmit} className="form-left">
            <h2 className="headline-1 text-center">Online Reservation</h2>

            <p className="form-text text-center">
              Booking request{' '}
              <a href="tel:+16263637268" className="link">
                +1 626-363-7268
              </a>{' '}
              or fill out the order form
            </p>

            <div className="input-wrapper">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                autoComplete="off"
                className="input-field"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                autoComplete="off"
                className="input-field"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-wrapper">
              <div className="icon-wrapper">
                <ion-icon name="person-outline" aria-hidden="true"></ion-icon>
                <select
                  name="person"
                  className="input-field"
                  value={formData.person}
                  onChange={handleChange}
                >
                  <option value="1-person">1 Person</option>
                  <option value="2-person">2 Person</option>
                  <option value="3-person">3 Person</option>
                  <option value="4-person">4 Person</option>
                  <option value="5-person">5 Person</option>
                  <option value="6-person">6 Person</option>
                  <option value="7-person">7 Person</option>
                </select>
                <ion-icon name="chevron-down" aria-hidden="true"></ion-icon>
              </div>

              <div className="icon-wrapper">
                <ion-icon name="calendar-clear-outline" aria-hidden="true"></ion-icon>
                <input
                  type="date"
                  name="date"
                  className="input-field"
                  value={formData.date}
                  onChange={handleChange}
                  required
                />
                <ion-icon name="chevron-down" aria-hidden="true"></ion-icon>
              </div>

              <div className="icon-wrapper">
                <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
                <select
                  name="time"
                  className="input-field"
                  value={formData.time}
                  onChange={handleChange}
                >
                  {[...Array(15)].map((_, i) => {
                    const hour = i + 8;
                    const time = hour <= 12 ? `${hour < 10 ? '0' : ''}${hour}:00am` : `${hour - 12 < 10 ? '0' : ''}${hour - 12}:00pm`;
                    return (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    );
                  })}
                </select>
                <ion-icon name="chevron-down" aria-hidden="true"></ion-icon>
              </div>
            </div>

            <textarea
              name="message"
              placeholder="Message"
              autoComplete="off"
              className="input-field"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <button type="submit" className="btn btn-secondary">
              <span className="text text-1">Book A Table</span>
              <span className="text text-2" aria-hidden="true">
                Book A Table
              </span>
            </button>
          </form>

          <div
            className="form-right text-center"
            style={{ backgroundImage: "url('/assets/images/form-pattern.png')" }}
          >
            <h2 className="headline-1 text-center">Contact Us</h2>

            <p className="contact-label">Booking Request</p>

            <a href="tel:+16263637268" className="body-1 contact-number hover-underline">
              +1 626-363-7268
            </a>

            <div className="separator"></div>

            <p className="contact-label">Location</p>

            <address className="body-4">
              1655 S Azusa Ave Ste E <br />
              Hacienda Heights, CA 91745
            </address>

            <p className="contact-label">Lunch Time</p>

            <p className="body-4">
              Monday to Sunday <br />
              11.00 am - 2.30pm
            </p>

            <p className="contact-label">Dinner Time</p>

            <p className="body-4">
              Monday to Sunday <br />
              05.00 pm - 10.00pm
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReservationSection;
